import React, { useState, useEffect } from 'react'
import ControlTowerMap from './child/ControlTowerMap';
import config from '../config';
import { auth } from '../helper/auth';

const MapsLayer = () => {
    const [venues, setVenues] = useState([]);

    useEffect(() => {
        fetchVenues();
    }, []);

    const fetchVenues = async () => {
        try {
            const response = await auth.fetch(`${config.API_BASE_URL}/api/venues`);
            if (response.ok) {
                const data = await response.json();
                if (Array.isArray(data)) {
                    setVenues(data);
                } else {
                    console.error('Venues data is not an array:', data);
                    setVenues([]);
                }
            } else {
                console.error('Failed to fetch venues:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching venues for map:', error);
        }
    };

    return (
        <section className="row gy-4">
            <div className="col-12">
                <ControlTowerMap venues={venues} />
            </div>
        </section>
    )
}

export default MapsLayer
